export default __webpack_public_path__ + "b8aad635d65fcc2e6600e332b875cf37.svg";